import { render, staticRenderFns } from "./AmountInputFormated.vue?vue&type=template&id=a6c688fa&"
import script from "./AmountInputFormated.vue?vue&type=script&lang=js&"
export * from "./AmountInputFormated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports